export default "__VITE_ASSET__CceoQDe2__"